import LoadMore from './load-more';

/**
 * LoadMore Configuration
 * Sets up the LoadMore component with selectors for DOM elements.
 */
const loadMoreConfig = {
  name: 'loadMore',
  class: LoadMore,
  querySelector: {
    loadMoreButton: '.load-more--is-available a',
    postList: '.post-list',
  },
};

export default loadMoreConfig;
